// extracted by mini-css-extract-plugin
export default {"heading":"heading__P1NG6"};